import { render, staticRenderFns } from "./featureUsage.vue?vue&type=template&id=164a2852&scoped=true&"
import script from "./featureUsage.vue?vue&type=script&lang=js&"
export * from "./featureUsage.vue?vue&type=script&lang=js&"
import style0 from "./featureUsage.vue?vue&type=style&index=0&id=164a2852&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164a2852",
  null
  
)

export default component.exports